import { handwritten } from "./tokens";

// Editorial CTA. `primary` = salmon→ink invert; `ghost` = outline.
// Empty `url` renders a disabled "soon" state.
export function RsvpButton({
  url,
  label,
  sub,
  variant,
}: {
  url: string;
  label: string;
  sub?: string;
  variant: "primary" | "ghost";
}) {
  const isLive = url.length > 0;
  const base =
    "w-full rounded-xl px-5 py-4 transition-all flex items-center justify-center gap-2 font-semibold text-base";

  if (!isLive) {
    return (
      <div
        className={`${base} bg-gray-100 text-gray-400 cursor-not-allowed border-2 border-gray-200`}
        aria-disabled="true"
      >
        <span>{label}</span>
        <span className="text-sm text-gray-400" style={handwritten}>
          soon
        </span>
      </div>
    );
  }

  if (variant === "primary") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={`${base} bg-salmon text-on-salmon hover:bg-salmon`}
      >
        <span>{label}</span>
        {sub && <span className="text-xs opacity-70 font-normal">· {sub}</span>}
        <span aria-hidden>→</span>
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={`${base} bg-canvas border-2 border-ink/15 hover:border-ink hover:bg-salmon-light text-ink`}
    >
      <span>{label}</span>
    </a>
  );
}
